import { supabase } from '../lib/supabase'

export const employeeService = {
  schemaName: 'public',
  tableName: 'Empleados',

  async getAll() {
    try {
      const { data, error } = await supabase
        .schema('public')
        .from('Empleados')
        .select('*')

      if (error) throw error

      return {
        success: true,
        data,
        error: null,
      }
    } catch (error) {
      console.error('Error fetching employees:', error)

      return {
        success: false,
        data: null,
        error: error.message,
      }
    }
  },

  async getByUserId(id) {
    try {
      const { data, error } = await supabase
        .schema('public')
        .from('Empleados')
        .select('*')
        .eq('id_user', id)
        .single()

      if (error) throw error

      return {
        success: true,
        data,
        error: null,
      }
    } catch (error) {
      console.error('Error fetching employee by userId:', error)

      return {
        success: false,
        data: null,
        error: error.message,
      }
    }
  },
}
